import footComponents from './index.vue'
const foot = {
  install: function (Vue) {
    Vue.component('foot', footComponents)
  }
}
export default foot



// WEBPACK FOOTER //
// ./src/components/foot/index.js